import { render, staticRenderFns } from "./groupProduct.vue?vue&type=template&id=3d9d9c43&scoped=true"
import script from "./groupProduct.vue?vue&type=script&lang=js"
export * from "./groupProduct.vue?vue&type=script&lang=js"
import style0 from "./groupProduct.vue?vue&type=style&index=0&id=3d9d9c43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9d9c43",
  null
  
)

export default component.exports